import {Route} from '@angular/router'
import {HomePageResolver} from './home-page.resolver'
import {HomePageComponent} from './home-page.component'

export default [
  {
    path: '',
    component: HomePageComponent,
    resolve: {
      content: HomePageResolver,
    },
  },
] satisfies Route[]
